import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Privacy Policy</h2>
            <p>Dreamehome Privacy Policy</p>
            <p>Introduction</p>
            <p>Operated by Dreame Innovation Technology (Suzhou) Co., Ltd. and its affiliates (hereinafter referred to as "we"
                or
                "Dreame"), the "Dreamehome" business provides you with a platform (or services) for intelligent hardware device
                control and management services. We understand and are fully aware of the importance of personal information to
                you,
                and we will do our best to protect the security of your personal information. We will adopt security protection
                measures to protect your personal information in accordance with the industry-recognized security standards.</p>
            <p>Before using our products (or services), please carefully read and understand the Dreamehome Privacy Policy.</p>
            <p>If you are a minor, you must have your parent or legal guardian’s permission to use this app and have them read
                these terms with you.</p>
            <p>We have given full consideration to your needs while formulating this Privacy Policy. It is very important that
                you
                fully understand our personal information collection and use practices, as well as our efforts to ensure that
                you
                can ultimately manage and control your personal information provided to us. This Privacy Policy covers how we
                collect, use, disclose, process and retain the information you provide to us when using our app. We will
                strictly
                abide by this Privacy Policy while using your information.</p>
            <p>This Privacy Policy will help you understand:</p>
            <p>1. What information we collect, and how we use it</p>
            <p>2. How we use Cookies and similar technologies</p>
            <p>3. How we entrust the processing of, share, transfer and publicly disclose your personal information</p>
            <p>4. How we retain and secure your personal information</p>
            <p>5. Description of System Permissions and Functions We Use</p>
            <p>6. Your rights</p>
            <p>7. How we handle cross-border data transmission</p>
            <p>8. Our contact information</p>
            <p>9. How we update the privacy policy</p>
            <p>Appendix I: Third-party SDK Details</p>
            <p>It is our ultimate goal to offer you the best user experience. We have dedicated Data Protection Officers (DPOs)
                based in different countries and regions to handle your data privacy issues. If you have any questions about
                this
                Privacy Policy, you can reach out to corresponding DPO with the contact information in Section VII. Our DPO will
                respond to your request within the time required by relevant national policies and laws. If you are not
                satisfied
                with our response, especially when you believe that our personal information processing behavior has caused harm
                to
                your legitimate rights and interests, you can file a lawsuit in the people’s court with jurisdiction, make a
                complaint to government regulatory agencies, or solve your problems with other external approaches.</p>
            <p>I. What information we collect, and how we use it</p>
            <p>Personal Information refers to any information recorded electronically or in other ways that can be used alone or
                in combination with other information to identify a specific natural person.</p>
            <p>Sensitive Personal Information refers to information that once leaked, illegally provided or abused, could
                endanger
                personal and property safety, or easily lead to damages to personal reputation, mental &amp; physical health, or
                discriminatory treatment, etc. Sensitive Personal Information includes but not limited to ID numbers, personal
                biometric information, bank account information, property information, records of whereabouts, transaction
                information, and the personal information of minors under the age of 14 (including), etc.</p>
            <p>The purpose of collecting your personal information is to provide products and/or services to you, and we ensure
                that we will use it in accordance with applicable laws, regulations and other normative documents. You have the
                right to choose whether to provide your information. But in most cases, if you do not provide it, we may not be
                able
                to provide you with corresponding services and respond to your requests.</p>
            <p>(I) Dreamehome collects and processes your personal information to deliver fundamental services</p>
            <p>(1) Device connection and management</p>
            <p>In order to deliver our services so that you can safely connect and manage your smart devices, we may collect
                your
                Wi-Fi information, location information, login account information, related mobile phone information, smart
                device
                information, and associated information of your Dreame account and smart device. The information will be used to
                enable features like Quick Connect, Connection, Find Nearby Devices and Device Management. Specifically, the
                information we collect includes:</p>
            <p>Login account information: your Dreame account username, password, nickname, profile photo, email address, and
                phone number. Among them, your username, password, phone number, and email address are sensitive personal
                information. Such information is collected to verify your identity and help you obtain the permission to access
                the
                server with your Dreamehome account. The username and password that you input will be encrypted and transmitted
                to
                Dreame server for login authentication.</p>
            <p>Mobile phone related information: device identification (IMEI/OAID, Mac address, and Android ID), phone model,
                system version, country or region, screen size and resolution, CPU and related display device information. These
                information is collected to enable you to connect the Dreamehome with your smart devices.</p>
            <p>Smart device information: device name, model, version, manufacturer, identifier, MAC address, IP address,
                operation
                status, custom attributes, setting parameters business events, device control and use records. These information
                is
                collected to bind your smart device so that you can control and manage the device, set device properties and
                parameters, and view the operation status and histories of your device.</p>
            <p>(2) Updating your Dreamehome and smart device</p>
            <p>In order to ensure that you can continuously enjoy our latest services, we may use your Dreamehome version
                information and phone model to provide updated services. Besides, we may also collect your connected device list
                and
                version information to provide updated services so that you can use the latest version of our services
                (including
                the firmware version). Dreamehome only provides updated services for your smart devices. The smart device
                manufacturer provides corresponding firmware and hall be responsible for the firmware quality and update
                results.
            </p>
            <p>If you choose not to provide these information, you will not be able to update Dreamehome and your smart device.
            </p>
            <p> (3) Online problem feedback</p>
            <p>In order to help you effectively solve possible problems of Dreamehome and your smart device, we offer an online
                problem feedback service, which requires your personal information, including: logs of Dreamehome and your smart
                device, your contact information, problem descriptions, and relevant photos and videos. The app and device logs
                include device status, information detected by sensors, device operation records, device identifiers, etc. These
                information is collected to analyze and identify the causes of the problem. Your contact information is
                collected so
                that we can track and follow up the ticket and better assist you solving the problem.</p>
            <p>Your personal information will only be used for analyzing and solving problems and will not be disclosed
                publically
                or used for commercial interests . If you do not provide such information, we will not be able to effectively
                identify and solve your problems.</p>
            <p>(II) Dreamehome collects and processes your personal information to deliver additional functions</p>
            <p>Apart from delivering the fundamental services of Dreamehome, we may also need to collect and use your personal
                information for some additional functions. If you do not provide these information, you can still use the
                fundamental services of Dreamehome, but may not be able to use the additional functions that can bring you more
                convenience. In addition to fundamental services, Dreamehome also offers:</p>
            <p>User Experience Improvement Program:</p>
            <p>In order to improve your user experience, we need to collect the Dreamehome logs, including encrypted key process
                logs, event logs, fault logs, business events, usage of each interface, etc. Your sensitive personal information
                will not be recorded in the logs.</p>
            <p>Your personal information will be used in the following ways: the above information will be automatically
                collected
                and uploaded to the server; the log information will be analyzed to diagnose the operation status and analyze
                app
                usage.</p>
            <p>If you do not provide these information, Dreamehome will not be able to timely improve your user experience, but
                you can still use the fundamental services of Dreamehome.</p>
            <p>(III) We may collect your personal information from third parties</p>
            <p>In some circumstances, we may lawfully acquire your personal information from a third party. </p>
            <p>With your authorization, we will cooperate with third-party service providers in the management of your smart
                devices, during which process we will collect your personal information from third-party service providers. If
                you
                manage your smart device with a third-party account, we will obtain your personal information when your app is
                bound
                with the third-party account. The following information will be collected:</p>
            <p>Your third-party account information, including your nickname and profile photo, which will be shown in
                Dreamehome;
            </p>
            <p>Device and network information, including device identifier, MAC address, and device’s serial number to recognize
                the current device and enable security control.</p>
            <p>If the processing of your personal information for business activities exceeds the scope of your original
                authorization and consent when you provide the information to a third-party service provider, we will obtain
                your
                clear consent before processing your information. Besides, we will strictly abide by relevant laws and
                regulations
                and require the relevant third-party service providers to guarantee the legality of the information they
                provide.
            </p>
            <p>(IV) Non-personal information</p>
            <p>We may also collect other information that cannot be used to identify a specific individual (i.e., information
                that
                is not personally identifiable), such as statistical data generated when you use a specific service, like user
                behaviors (including clicks, page jumps, and browsing time) . These information is collected to improve our
                services. The types and quantities of information collected depend on how you use our products and/or services.
                We
                will gather these information to help us provide more user-friendly information, and better understand customer
                preference for our website, products and services so that we can optimize our services. In this Privacy Policy,
                the
                gathered data shall be regarded as non-personal information. When we combine non-personal information with
                personal
                information in use, the non-personal information shall be regarded as personal information.</p>
            <p>II. How we use Cookie and similar technologies</p>
            <p>To ensure normal functioning of Dreamehome, we will store a small data file named Cookie on your device. Cookie
                normally includes identifiers, site names and some numbers and characters. With the help of Cookie, Dreamehome
                can
                store your website login account, preferences and other data.</p>
            <p>We will not use Cookie for any purpose other than those stated in this Privacy Policy. You can manage or delete
                Cookie according to your preferences. But if you do this, in some cases, your safe access to Dreamehome may be
                affected, and you may need to change user settings every time you access Dreamehome.</p>
            <p>III. How we entrust the processing of, share, transfer and publicly disclose your personal information</p>
            <p>(I) Entrusted processing</p>
            <p>Under some circumstances, Dreame may entrust other companies to process your personal information, such as
                contacting you, sending emails or providing technical support on our behalf. These companies can only use your
                personal information to provide services to you on our behalf.</p>
            <p>We will sign a strict confidentiality agreement or personal information processing agreement with the entrusted
                party, and require them to process personal information in accordance with this Privacy Policy and adopt
                relevant
                confidentiality and security measures.</p>
            <p>(II) Sharing</p>
            <p>In general circumstances, Dream will not share your personal information with other companies, organizations, or
                individuals except in the following cases:</p>
            <p>1. With your consent, we will share the information within your authorization with a third party, which includes
                the information and configuration of your smart home products of your relatives and friends sharing the products
                with you to help them obtain a quick access to the software and services on their terminal devices.</p>
            <p>2. Some services of Dreamehome, such as website hosting, data analysis, payment and credit card processing,
                infrastructure supply, IT services, customer support services, email sending services and other similar
                services,
                are provided by third-party service providers. For this reason, we need to provide some of your personal
                information
                to the third-party service providers so that they can deliver these services to us.</p>
            <p>3. We may disclose your personal information to customers and other business partners who directly or indirectly
                provide smart devices and/or network and systems for you to access and use our website and services.</p>
            <p>4. If Dreame is involved in a reorganization, merger, sales of assets, joint venture, abalienation, transfer or
                other circumstances where all or part of our business, assets or stocks need to be disposed (including but not
                limited to any bankruptcy or similar proceedings related to the above circumstances), we may disclose your
                personal
                information to affiliated companies or other third parties. Prior to this, you will receive a clear notification
                via
                email and/or our website regarding the change of ownership, the incompatibility of new usage of personal
                information, and the authorization of your personal information.</p>
            <p>5. If we have a good-faith belief that the access, use, preservation, or disclosure of the information is
                reasonably necessary to: (a) comply with applicable laws and regulations; (b) comply with legal procedures; (c)
                respond to the requirements of public institutions and government authorities, including those outside the
                country/region where you live; (d) fulfill our terms and conditions; (e) protect our operations, business and
                systems; (f) protect the rights, privacy, safety or property of us and/or other users, including you; and (g)
                seek
                available remedies or limit the damage compensations that we may need to provide.</p>
            <p>6. We may disclose your personal information to our branches or affiliated companies to carry out business
                activities on a regular basis.</p>
            <p>7.We will share necessary data with third parties through application programming interfaces (APIs) and software
                tool development kits (SDKs). The third-party SDKs vary from different versions, generally including third-party
                account login types, sharing types, and third-party account payment types, manufacturer push types, statistic
                types,
                etc. We will conduct strict security inspections on third parties and agree on data protection measures. In
                Appendix
                1, we have listed the details of the third-party SDKs that we authorized to access, please read it carefully.
                Our
                Privacy Policy does not apply to products or services provided by third parties. Your personal information may
                be
                collected when you use these products or services. Therefore, we highly recommend that you take the time to read
                the
                privacy policy of the third parties, just like reading ours. We have no responsibility for and control on how
                third
                parties use the information they collect from you. Our Privacy Policy does not apply to other websites linked
                through our services. You should be responsible for the safety of your personal information while interacting
                with
                the linked websites. Before you enter the third-party page for the first time, the third-party service provider
                will
                show you relevant agreements and privacy statements. Please read their statements carefully.</p>
            <p>(III) Transfer</p>
            <p>Dreame will not transfer your personal information to any companies, organizations, or individuals except in the
                following cases:</p>
            <p>1. With your explicit consent: we will only transfer your personal information to other parties after obtaining
                your explicit consent;</p>
            <p>2. If Dream is involved in a merger, acquisition or bankruptcy liquidation that requires for the transfer of
                personal information, we will require that the new company or organization holding your personal information to
                continue to be bound by this Privacy Policy, otherwise we will require the company or organization to acquire
                authorization from you again.</p>
            <p>(IV) Public Disclosure</p>
            <p>We do not publicly disclose your personal information except under the following circumstances:</p>
            <ol>
                <li>With your explicit consent;</li>
                <li>When we have a legal basis: we may publicly disclose your personal information in compliance with the law or
                    based on legal procedures, litigation, or mandatory requirements of government authorities.</li>
            </ol>
            <p>IV. How we retain and secure your personal information</p>
            <p>We retain personal information within the period necessary for the purpose of information collection described in
                this Privacy Policy, or comply with applicable legal requirements. We will stop storing your personal
                information
                and delete or anonymize it after we complete the collection purpose, or after we confirm your deletion or
                cancellation application, or after we terminate the operation of corresponding products or services. If it is
                for
                public interest, scientific, historical research or statistical purposes, we will continue to retain relevant
                data
                based on applicable laws, even if further data processing has nothing to do with the original collection
                purpose.
            </p>
            <p>In the Dreamehome business, the specific retention time of your personal data is as follows:</p>
            <p>For data stored locally in Dreamehome, when you uninstall the app or clear the app data, all the stored data will
                be deleted immediately.</p>
            <p>For the smart device and business data store on the server, when you delete the smart device, refuse to agree
                with
                Dreamehome’s Privacy Policy and stop using Dreamehome services, all the stored data will be deleted immediately.
            </p>
            <p>For business logs, statistical data and historical records stored on the server, we delete them when cleaning up
                the server data from time to time. Normally the data is retained no longer than 2 years.</p>
            <p>Besides, in case that Dreame stops the operation of corresponding products or services, we will inform you
                through
                push notifications, announcements, etc. and delete your personal information or anonymize it within a reasonable
                period of time.</p>
            <p>V. Description of System Permissions and Functions We Use</p>
            <p>For the purpose of realizing product functions and delivering safe and stable operations, we may apply for or use
                the relevant permissions of the operating system. If you do not allow us to use these permissions, it will not
                affect your use of our basic service functions (except for the necessary operating system permissions that the
                basic
                business functions rely on), but you may not be able to enjoy the user experience brought by additional
                services.
                You can view the status of the permissions one by one in your device settings, and determine whether to turn on
                or
                off these permissions at any time. Please note that the above permissions are turned off by default. When you
                turn
                on any of the permissions, it means you authorize us to collect and use relevant personal information to provide
                you
                with corresponding services. Once you turn off any of the permissions, it means that you have cancelled the
                authorization, and we will not continue to collect and use relevant personal information based on the
                corresponding
                permissions, nor will we be able to provide you with the corresponding services. However, your decision to turn
                off
                the permissions will not affect the previous collection and use of information based on your authorization.</p>
            <p>According to product upgrades, the types and purposes of application and use of permissions may vary. We will
                adjust the list according to these changes in a timely manner to ensure that you are informed about the
                application
                and use of permissions accordingly.</p>
            <p>In order to protect your right to know, we use the following list to display the relevant operating system
                permissions that the product may apply for and use. You can manage the relevant permissions according to your
                actual
                needs.</p>
            <p>List of application permissions that the Android version will get:</p>
            <div className='tableStyle'>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <p>Name of permissions</p>
                            </td>
                            <td>
                                <p>Permission function description</p>
                            </td>
                            <td>
                                <p>Scenarios and purposes</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Shoot</p>
                            </td>
                            <td>
                                <p>Shoot photos</p>
                            </td>
                            <td>
                                <p>Used for the shooting of account avatars; used for audio and video calls of sweeping machines with
                                    audio and
                                    video functions; used for uploading user feedback information for after-sales services.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Access precise positioning</p>
                            </td>
                            <td>
                                <p>Obtain accurate geographic location information through Global Positioning System (GPS) or network
                                    location
                                    information (such as base stations and WLAN)</p>
                            </td>
                            <td>
                                <p>Used to find a compatible sweeping machine nearby during the process of connecting the product to a
                                    Wi-Fi
                                    network</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Record</p>
                            </td>
                            <td>
                                <p>Use the microphone to record audio</p>
                            </td>
                            <td>
                                <p>Used for audio and video calls of sweeping machines with audio and video functions; used for
                                    uploading user
                                    feedback information for after-sales services.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Read phone status</p>
                            </td>
                            <td>
                                <p>Provide information such as symbols of the mobile phone. please be rest-assured that this permission
                                    cannot
                                    monitor or obtain any content and information of your calls.</p>
                            </td>
                            <td>
                                <p>Read the device identification code, identify the mobile device ID, and accurately send device status
                                    in push
                                    notifications.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Read external storage</p>
                            </td>
                            <td>
                                <p>Provide the function of reading the data in the storage of the mobile phone</p>
                            </td>
                            <td>
                                <p>Allow the App to read the image files in the storage, set the account avatar; upload user feedback
                                    information for after-sales services.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Write external storage</p>
                            </td>
                            <td>
                                <p>Provide the functions of writing external storage</p>
                            </td>
                            <td>
                                <p>Allow the App to write/download/save/modify/delete information such as pictures, files, and crash
                                    logs.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p>VI. Your rights</p>
            <p>(I) Access, rectification and deletion</p>
            <p>In accordance with the local applicable laws and regulations, you have the right to request to access, rectify or
                delete any information we collect from you (hereinafter referred to as the “request”). Please write to us or
                contact
                us by visiting Dreamehome. According to most laws, the request of a personal information subject should comply
                with
                specific requirements. </p>
            <p>In this Privacy Policy, requirements on personal information subjects include:</p>
            <p>The request should be made through our dedicated request channels. To ensure the security of your personal
                information, the request should be in written form (unless the local law clearly recognizes a verbal request);
            </p>
            <p>You need to provide enough information for us to verify your identity and ensure that the request is made by the
                user himself or person legally authorized by the user;</p>
            <p>Once we have acquired sufficient information to confirm that we can process your request, we will respond to you
                within the time specified by applicable data protection laws. Specifically, our responses include:</p>
            <p>Based on your request and applicable laws and regulations, we can provide you a copy of your information that we
                collected and processed free of charge. For other requests for relevant information, we may charge a reasonable
                fee
                based on our actual management costs in accordance with applicable laws.</p>
            <p>If you believe that any of your information we hold is incorrect or incomplete, you can request to rectify or
                complete the information based on the purpose of use.</p>
            <p>According to applicable laws and regulations, you have the right to request to delete your personal data. Your
                request will be evaluated. If it complies with corresponding laws and regulations, we will delete your
                information
                with relevant procedures which involves technological measures. After relevant information is deleted by you or
                us
                with your consent, we may not be able to delete it from the backup system immediately due to relevant laws and
                security technologies. In such case, we will secure your personal information and isolate it from any further
                processing until it can be cleared or anonymized. For example, according to the <em>E-Commerce Law of the
                    People's
                    Republic of China,</em> your product and service information and transaction information shall be retained
                for at
                least three years from the day of completion of the transaction.</p>
            <p>We have the right to refuse to process a request in the following cases: the request is unreasonable or disputed;
                it may harm the privacy of others; it is extremely unrealistic; it requires disproportionate technical work; it
                can
                be ignored according to local laws; the information has been publicly disclosed; the information has been
                disclosed
                under confidentiality conditions. If we believe that, in some cases, the request to delete or access data may
                prevent us from legally using the data for the aforementioned anti-fraud and security purposes, we may also
                reject
                it.</p>
            <p>(II) Withdrawal of consent</p>
            <p>You can submit a request so as to revoke your consent concerning the collection, usage and/or disclosure of your
                personal information that we hold or control. According to the specific services you use, you can contact us for
                relevant operations through the contact information in Section 7 of this Privacy Policy. We will process your
                request within a reasonable time after you make it, and will thereupon no longer collect, use and/or disclose
                your
                personal information.</p>
            <p>Please note that depending on the scope within which you authorize us to process your information, as a result of
                your withdrawal of consent, you may not be able to access the services of Dreamehome or its connected smart
                devices.
                However, your decision to revoke your consent or authorization will not affect the previous processing of
                personal
                information based on your authorization.</p>
            <p>You can also opt-out the User Experience Improvement Program by requesting withdrawal of consent or visiting
                Dreamehome.</p>
            <p>(III) De-registration</p>
            <p>You can de-register a Dreamehome account by visiting "My"-"Account Settings"-"Account Cancellation". If you wish
                to
                cancel your Dreamehome account, it will prevent you from using Dreamehome and its entire line of smart hardware
                products and services. Please proceed with caution. In order to protect your legitimate rights and interests and
                those of others, we will determine whether to support your cancellation request based on your use of
                Dreamehome's
                intelligent hardware products and services.</p>
            <p>VII. How we handle cross-border data transmission</p>
            <p>Dreame relies on its resources and servers all over the world to provide products and/or services to you. Hence,
                with your consent, your personal information may be transferred to other jurisdictions outside the
                country/region
                where you are using the products or services, or may be accessed by these jurisdictions. The data protection
                policies and relevant laws in the country/region where your information may be transferred may not be as
                comprehensive as that in your current country/region. Under such circumstances, we will take appropriate and
                legal
                measures in accordance with applicable laws of corresponding jurisdiction to ensure that your personal
                information
                continues to be protected.</p>
            <p>Note:</p>
            <p>If you are a resident of the European Economic Area (EEA) and your personal information is transferred outside
                the
                EEA, we will: process your personal information within the area where the European Commission can provide a
                sufficient level of protection; or implement appropriate protective measures to safeguard your personal
                information,
                including transfering your information in accordance with applicable data transfer regulations, such as the
                European
                Commission’s Standard Contractual Clauses (SCC).</p>
            <p>VIII. Our contact information</p>
            <p>If you have any comments or questions about this Privacy Policy, or about our collection, use or disclosure of
                your
                personal information, please contact us through the contact information below or by visiting Dreamehome
                “My”-“Follow
                and Feedback” and title the message with "Privacy Policy". We will have our professional team to respond to your
                questions and problems. If your question involves rather important matters, we may ask you to provide more
                information. If you are not satisfied with our response, you can make a complaint to relevant supervisory
                authority
                in your jurisdiction. If you consult us about complaint channels, we will provide you with applicable options
                based
                on your actual situation.</p>
            <p><strong>Email Address:</strong></p>
            <ul>
                <li>Contact Information of Dreame in China: <a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></li>
                <li>Contact Information of the DPO in Singapore: <a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                <li> Contact Information of the EU representative: <a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
            </ul>
            <p><strong>Tel: </strong>400-875-9511</p>
            <p><strong>Website:</strong> <a className="page"
                href="https://www.dreame-technology.com">https://www.dreame-technology.com</a></p>
            <p>IX. How we update the terms</p>
            <p>Dreame reserves the right to update this Privacy Policy in a timely manner. In case of any changes, we will
                inform
                you through a pop-up message or other prominent means. Only with your consent will we collect, use and store
                your
                personal information in accordance with the updated policy.</p>
            <p>This policy takes effect from the date of update.</p>
            <p>Last update date: 08/28/2021</p>
            <p>Appendix I: Third-party SDK Details</p>
            <p>*Dreamehome uses a series of third-party SDKs to provide you with more professional and safer basic and
                additional
                features and services. Read more details about the third-party SDKs used in Dreamehome below:</p>
            <div className='tableStyle'>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <p>SDKs</p>
                            </td>
                            <td>
                                <p>Features</p>
                            </td>
                            <td>
                                <p>Information Collected</p>
                            </td>
                            <td>
                                <p>Third-Party Privacy Policy</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Umeng statistic analysis SDK</p>
                            </td>
                            <td>
                                <p>Statistic analysis</p>
                            </td>
                            <td>
                                <p>Device identifier (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO OF SIM CARD), location</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Umeng push notification SDK</p>
                            </td>
                            <td>
                                <p>Push notification</p>
                            </td>
                            <td>
                                <p>Device identifier (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO OF SIM CARD), location</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Umeng U-share SDK</p>
                            </td>
                            <td>
                                <p>Share with third parties</p>
                            </td>
                            <td>
                                <p>Device identifier (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO OF SIM CARD), location</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Agora SDK</p>
                            </td>
                            <td>
                                <p>Enable voice chat and video streaming</p>
                            </td>
                            <td>
                                <p>Device information, network status, camera, microphone, read and write storage</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Huawei data-push SDK</p>
                            </td>
                            <td>
                                <p>Data-push</p>
                            </td>
                            <td>
                                <p>Device identifier </p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Xiaomi data-push SDK</p>
                            </td>
                            <td>
                                <p>Data-push</p>
                            </td>
                            <td>
                                <p>Device identifier, device model, network type, device storage, device running process information,
                                    application version, SDK version</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>OPPO data-push SDK</p>
                            </td>
                            <td>
                                <p>Data-push</p>
                            </td>
                            <td>
                                <p>Device identifier </p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>VIVO data-push SDK</p>
                            </td>
                            <td>
                                <p>Data-push</p>
                            </td>
                            <td>
                                <p>Device identifier </p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>WeChat SDK</p>
                            </td>
                            <td>
                                <p>WeChat Login, Share to WeChat </p>
                            </td>
                            <td>
                                <p>Device identifier, network information</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>QQ SDK</p>
                            </td>
                            <td>
                                <p>Share to QQ</p>
                            </td>
                            <td>
                                <p>Device identifier, network information</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Weibo SDK</p>
                            </td>
                            <td>
                                <p>Weibo Login, Share to Weibo</p>
                            </td>
                            <td>
                                <p>Device identifier, network information</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Apple ID SDK</p>
                            </td>
                            <td>
                                <p>Apple ID Login</p>
                            </td>
                            <td>
                                <p>Apple ID</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.apple.com/legal/privacy/szh/">https://www.apple.com/legal/privacy/szh/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Alibaba Cloud HTTPDNS SDK</p>
                            </td>
                            <td>
                                <p>Optimize the network performance of push notifications</p>
                            </td>
                            <td>
                                <p>IP address</p>
                            </td>
                            <td>
                                <p>
                                    <a className="page"
                                        href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202108111133_15842.html?spm=a2c4g.11186623.0.0.9ae430e5ySBBwr">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202108111133_15842.html?spm=a2c4g.11186623.0.0.9ae430e5ySBBwr</a>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy
